import { ProgressBar } from 'react-bootstrap';

interface TeamWinRatioProps {
  wins: number;
  caps: number;
}

export default function TeamWinRatio({ wins, caps }: TeamWinRatioProps) {
  return (
    <ProgressBar now={40}>
      <ProgressBar key={1} variant="success" now={(wins / caps) * 100} label={wins} />
      <ProgressBar key={2} variant="danger" now={((caps - wins) / caps) * 100} label={caps - wins} />
    </ProgressBar>
  );
}
